import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { string } from 'prop-types'
import { HomeContainer } from 'homepage'
import { LeadContainer } from 'lead'
import { DashboardContainer } from 'dashboard'
import { Routes } from '../../../../config/routes'
import { PrivateRoute } from './PrivateRoute'

const Router = () => {
  return (
    <Switch>
      <Route
        path={Routes.Login}
        component={() => <DefaultComponent text="login" />}
      />
      <Route
        path={Routes.Calculator}
        component={() => <DefaultComponent text="calculator" />}
      />
      <Route
        path={Routes.Report}
        component={() => <DefaultComponent text="report" />}
      />
      <Route
        path={Routes.LeadForm.Auto}
        component={() => <DefaultComponent text="auto" />}
        exact
      />
      <PrivateRoute path={Routes.DashboardAutonomous} exact>
        <DashboardContainer />
      </PrivateRoute>
      <Route
        path={Routes.LeadForm.Home}
        component={() => <DefaultComponent text="home" />}
        exact
      />
      <PrivateRoute path={Routes.Leads.Details} exact>
        <LeadContainer />
      </PrivateRoute>
      <PrivateRoute path={Routes.Home}>
        <HomeContainer />
      </PrivateRoute>
    </Switch>
  )
}

const DefaultComponent = ({ text }) => <div>{text}</div>

DefaultComponent.propTypes = {
  text: string,
}

export { Router }
